import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import FeaturesSection from "@/components/FeaturesSection";
import WhySection from "@/components/WhySection";
import PremiumSection from "@/components/PremiumSection";
import WaitlistSection from "@/components/WaitlistSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import heroMockupFoods from "@/assets/hero-mockup-foods.webp";
import heroMockupFoods400 from "@/assets/hero-mockup-foods-400.webp";
import heroMockupFoods480 from "@/assets/hero-mockup-foods-480.webp";
import heroMockupFoods576 from "@/assets/hero-mockup-foods-576.webp";
import heroMockupFoods640 from "@/assets/hero-mockup-foods-640.webp";
import heroMockupFoods768 from "@/assets/hero-mockup-foods-768.webp";
import heroMockupFoods800 from "@/assets/hero-mockup-foods-800.webp";
import heroMockupFoods1024 from "@/assets/hero-mockup-foods-1024.webp";

const Index = () => {
  const { language, t } = useLanguage();
  const { pathname } = useLocation();
  const isEnglishUrl = pathname.startsWith("/en");

  const title = language === "de"
    ? "FreshKeeper – Lebensmittel clever verwalten"
    : "FreshKeeper – Smart Food Management App";

  const description = language === "de"
    ? "FreshKeeper ist eine Lebensmittelverwaltungs-App in Entwicklung. Weder die Android- noch die iOS-Version ist bisher veröffentlicht. Jetzt für den Start vormerken."
    : "FreshKeeper is a food management app in development. Neither the Android nor the iOS version has been released yet. Join the launch waitlist.";

  const keywords = language === "de"
    ? "Lebensmittel verwalten App, Haltbarkeitsdatum App, Lebensmittelverschwendung reduzieren, Vorratsverwaltung App, Kühlschrank organisieren App"
    : "food management app, expiry date tracker, reduce food waste, inventory management app, fridge organizer app";

  return (
    <>
      <Helmet>
        <html lang={language} />
        <link
          rel="preload"
          as="image"
          href={heroMockupFoods576}
          imageSrcSet={`${heroMockupFoods400} 400w, ${heroMockupFoods480} 480w, ${heroMockupFoods576} 576w, ${heroMockupFoods640} 640w, ${heroMockupFoods768} 768w, ${heroMockupFoods800} 800w, ${heroMockupFoods1024} 1024w, ${heroMockupFoods} 1280w`}
          imageSizes="(max-width: 640px) calc(100vw - 3rem), (max-width: 1024px) 512px, 576px"
          fetchPriority="high"
        />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <link rel="canonical" href={`https://freshkeeper.de${isEnglishUrl ? "/en/" : "/"}`} />
        <link rel="alternate" hrefLang="de" href="https://freshkeeper.de/" />
        <link rel="alternate" hrefLang="en" href="https://freshkeeper.de/en/" />
        <link rel="alternate" hrefLang="x-default" href="https://freshkeeper.de/" />
        
        {/* Open Graph */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://freshkeeper.de${isEnglishUrl ? "/en/" : "/"}`} />
        <meta property="og:image" content="https://storage.googleapis.com/gpt-engineer-file-uploads/cPU79xUvb3WoUzNQVY0o5sP1YzA3/social-images/social-1767357463145-GitHub Banner.png" />
        <meta property="og:site_name" content="FreshKeeper" />
        <meta property="og:locale" content={language === "de" ? "de_DE" : "en_US"} />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />

      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSection />
          <FeaturesSection />
          <WhySection />
          <PremiumSection />
          <WaitlistSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
